import BaseModule from '@core/modules/base-module/base-module';
import ThemesCard from '@core/components/cards/themes-card/themes-card';
//
const themesList = new BaseModule();
themesList.name = "themes-list";
themesList.init(that=>{
  const card=new ThemesCard(that.elements);
  card.init();
});
